// App.tsx
import React from "react";
import "./App.css";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

// Public Pages
import Home from "./pages/Home";
import LoginPage from "./pages/Authentication/LoginPage";
import SignupPage from "./pages/Authentication/SignupPage";
import ForgotPassword from "./pages/Authentication/callForgotPAssword";
import ForgotPasswordLink from "./pages/Authentication/ForgotPassword";
import ShowData from "./Components/ShowData";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import BulkUploadFarmers from "./MainMenu/Sub_components/Farmer Management/BulkUploadFarmers";
import SignUpPage_new from "./pages/Authentication/SignUpPage_new";
import Forgot_Password_new from "./pages/Authentication/Forgot_Password_new";
import Otp_verify from "./pages/Authentication/Otp_verify";
import Change_password from "./pages/Authentication/Change_password";
import UserDeletion from "./MainMenu/Sub_components/Deletion/UserDeletion";
import Deletion from "./MainMenu/Sub_components/Deletion/Deletion";

// Layout + Protected Wrapper
import TopNav from "./MainMenu/TopNav";
import DaillyNews from "./MainMenu/Sub_components/Market_Insights/Daily_news/DaillyNews";
import FarmerDashboard from "./MainMenu/Sub_components/Farmer Management/Dashboard/FarmerDashboard";
import FpoManage from "./MainMenu/Sub_components/FPOManagement/FpoManage";

// Lazy-loaded Protected Pages
const SaleComponent = React.lazy(() => import("./MainMenu/Sub_components/POI/SaleComponent"));
const InventoryComponent = React.lazy(() => import("./MainMenu/Sub_components/POI/InventoryComponent"));
const ReportComponent = React.lazy(() => import("./MainMenu/Sub_components/POI/ReportComponent"));
const CropLibraryComponent = React.lazy(() => import("./MainMenu/Sub_components/Crop Insights/CropLibraryComponent"));
const Farmer_registration = React.lazy(() => import("./MainMenu/Sub_components/Farmer Management/Farmer_registration"));
const Mandi_price = React.lazy(() => import("./MainMenu/Sub_components/Market_Insights/Mandi_Price/Mandi_price"));
const Cultivation = React.lazy(() => import("./MainMenu/Sub_components/Farmer Management/Cultivation/Cultivation"));
const View_enquiry = React.lazy(() => import("./MainMenu/Sub_components/Enquiry_management/View_enquiry"));
const My_enquiry = React.lazy(() => import("./MainMenu/Sub_components/Enquiry_management/My_enquiry"));
const Post_enquiry = React.lazy(() => import("./MainMenu/Sub_components/Enquiry_management/Post_enquiry"));
const Market_insights = React.lazy(() => import("./MainMenu/Sub_components/Market_Insights/Market_insight/Market_insights"));

// Auth Guard
const AuthGuard: React.FC = () => {
  const auth = localStorage.getItem("authToken");
  return auth ? <Outlet /> : <Navigate to="/" />;
};

function App() {
  return (
    <div className="App font-roboto box-border m-0 p-0">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/password-reset" element={<ForgotPasswordLink />} />
        <Route path="/showFPOData" element={<ShowData />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/bulk" element={<BulkUploadFarmers />} />
        <Route path="/new_signup" element={<SignUpPage_new />} />
        <Route path="/forgot-password-new" element={<Forgot_Password_new />} />
        <Route path="/otp-verify" element={<Otp_verify />} />
        <Route path="/change-password" element={<Change_password />} />
        <Route path="/user_deletion" element={<UserDeletion />} />
        <Route path="/deletion" element={<Deletion />} />

        {/* Protected Routes under /top */}
        <Route element={<AuthGuard />}>
          <Route path="/top" element={<TopNav />}>
            {/* default redirect */}
            <Route index element={<Navigate to="pos/sale" replace />} />
            <Route path="pos/sale" element={<SaleComponent />} />
            <Route path="pos/inventory" element={<InventoryComponent />} />
            <Route path="pos/report" element={<ReportComponent />} />
            <Route path="crop/library" element={<CropLibraryComponent />} />
            <Route path="farmer/registration" element={<Farmer_registration />} />
            <Route path="market/mandi" element={<Mandi_price startDate={null} endDate={null} />} />
            <Route path="farmer/cultivation" element={<Cultivation />} />
            <Route path="enquiry/view" element={<View_enquiry />} />
            <Route path="enquiry/my" element={<My_enquiry />} />
            <Route path="enquiry/post" element={<Post_enquiry />} />
            <Route path="market/insights" element={<Market_insights />} />
            <Route path="market/daily-news" element={<DaillyNews />} />
            <Route path="farmer/dashboard" element={<FarmerDashboard />} />
            <Route path="FpoManagement/FpoManage" element={<FpoManage />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;